import { AUTH } from "../actions/auth"
import type { AuthState } from "./store"

type AuthAction = { type: string; payload?: unknown }

export default function reducer(state: AuthState = null, { type, payload }: AuthAction): AuthState {
  // eslint-disable-next-line security/detect-possible-timing-attacks -- comparing Redux action types is not timing-sensitive
  if (type === AUTH) {
    return payload as AuthState
  }
  return state
}
